import { render, staticRenderFns } from "./ti5.vue?vue&type=template&id=57ce919a&scoped=true&"
import script from "./ti5.vue?vue&type=script&lang=js&"
export * from "./ti5.vue?vue&type=script&lang=js&"
import style0 from "./ti5.vue?vue&type=style&index=0&id=57ce919a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57ce919a",
  null
  
)

export default component.exports